import { Button, Input, Modal } from "antd";
import { useEffect, useState } from "react";

export default function ({ quantity, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [internalValue, setInternalValue] = useState([]);

  useEffect(() => {
    const nv = Array(quantity ?? 0).fill(null);
    setInternalValue(nv);
    onChange(nv);
  }, [quantity]);

  useEffect(() => {
    setInternalValue(value);
  }, [open, value]);

  return (
    <div>
      {quantity > 0 && <Button type="link" onClick={() => setOpen(true)}>
        Carica matricole
      </Button>}
      <Modal
        title="Carica i numeri di serie"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => {
          onChange(internalValue);
          setOpen(false);
        }}
      >
        {(internalValue ?? []).map((item, index) => (
          <Input
            key={index}
            autoComplete="off"
            value={item}
            onChange={(e) =>
              setInternalValue(internalValue.map((x, i) => (index === i ? e.target.value : x)))
            }
          />
        ))}
      </Modal>
    </div>
  );
}
